import { createStore, combineReducers } from 'redux';
import reduceFilters from './reducers/filtersReducer'
import reduceAggrega from './reducers/aggregaReducer'
import reduceMenu from './reducers/menuReducer'
import reduceLoader from './reducers/loaderReducer'
import reduceLang from './reducers/langReducer'
import reduceLogo from './reducers/logoReducer'
import reduceAggregaSDR from './reducers/aggregaReducerSDR';

const rootReducer = combineReducers({
    reduceFilters: reduceFilters,
    reduceAggrega: reduceAggrega,
    reduceAggregaSDR: reduceAggregaSDR,
    reduceMenu: reduceMenu,
    reduceLoader: reduceLoader,
    reduceLang: reduceLang,
    reduceLogo: reduceLogo
})


export default createStore(rootReducer)